module.exports = __webpack_public_path__ + "img/clock-icon.bcca75e8.svg";